export default __webpack_public_path__ + "static/media/safety.8a7c0142.webp";